import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DEFAULT_WHO_TO_CALL, activeListLabels } from '../../../../constants/task-lists';

export interface CallRxDialogData {
  notes?: string;
  whoToCall?: string;
  date?: string | Date;
  whoToCallOptions?: string[];
}

export interface CallRxDialogResult {
  notes: string;
  whoToCall: string;
  date: Date | null;
}

@Component({
  selector: 'app-call-rx-dialog',
  template: `
    <h2 mat-dialog-title>CALL / RX</h2>
    <mat-dialog-content>
      <p class="task-popup-message">
        Record who needs to be called and any context for the CALL / RX task.
      </p>
      <mat-form-field appearance="fill" class="task-popup-field">
        <mat-label>WHO TO CALL</mat-label>
        <mat-select [formControl]="whoToCall">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let option of options" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        *ngIf="whoToCall.value === 'Other'"
        appearance="fill"
        class="task-popup-field"
      >
        <mat-label>OTHER</mat-label>
        <input matInput type="text" autocomplete="off" [formControl]="whoToCallOther">
      </mat-form-field>
      <mat-form-field appearance="fill" class="task-popup-field">
        <mat-label>DATE</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill" class="task-popup-field">
        <mat-label>NOTES</mat-label>
        <textarea matInput rows="4" [formControl]="notes"></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">CANCEL</button>
      <button mat-raised-button color="primary" type="button" (click)="save()">
        SAVE
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .task-popup-message {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.4;
      }
      .task-popup-field {
        width: 100%;
      }
    `,
  ],
})
export class CallRxDialogComponent {
  options: string[] = [];
  whoToCall = new FormControl('');
  whoToCallOther = new FormControl('');
  notes = new FormControl('');
  date = new FormControl(null);

  constructor(
    public dialogRef: MatDialogRef<CallRxDialogComponent, CallRxDialogResult | null>,
    @Inject(MAT_DIALOG_DATA) public data: CallRxDialogData
  ) {
    this.options = data?.whoToCallOptions?.length
      ? data.whoToCallOptions
      : activeListLabels(undefined, DEFAULT_WHO_TO_CALL);
    this.notes.setValue(String(data?.notes || ''));
    const who = String(data?.whoToCall || '');
    if (who && !this.options.includes(who)) {
      this.whoToCall.setValue('Other');
      this.whoToCallOther.setValue(who);
    } else {
      this.whoToCall.setValue(who);
    }
    this.date.setValue(this.parseDate(data?.date) || new Date());
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    const who =
      this.whoToCall.value === 'Other'
        ? String(this.whoToCallOther.value || '').trim()
        : String(this.whoToCall.value || '').trim();
    this.dialogRef.close({
      notes: String(this.notes.value || '').trim(),
      whoToCall: who,
      date: this.parseDate(this.date.value),
    });
  }

  private parseDate(value?: string | Date | null): Date | null {
    if (!value) {
      return null;
    }
    const date = value instanceof Date ? value : new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
}
